module.exports = __webpack_public_path__ + "app_70x70.508bd030710e1d90c521eb18f03d2ac9.png";